<template>
  <div id="navBar" class="text-xl text-white font-jost" style="height: 3vw">
    <div :id="'navBar' + headerStore.selectedMenu.id" class="flex justify-end items-center w-full space-x-14 h-full last:pr-20" :style="navBarStyle(headerStore.selectedMenu.id)">
      <template v-for="(item, index) in headerStore.selectedMenu.navbarList" :key="'navItem' + index">
        <span
          class="cursor-pointer hover-border"
          :class="{ 
            'hover-border-active': isMouseOver === index && !(headerStore.routerName == item.id),
            'hover-border-selected': isMatchCurrentPath(item.id),
            'corpColor': headerStore.selectedMenu.id == 'corporate',
            'insuColor': headerStore.selectedMenu.id == 'insurer',
            'patiColor': headerStore.selectedMenu.id == 'patients',
            }"
          @mouseover="isMatchCurrentPath(item.id)"
          @mouseleave="updateMouseOver(null)"
          @click="click(item, headerStore.selectedMenu)">
          {{ t(item.label) }}</span>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import { useHeaderStore } from "@/stores/header";
import { useCorporateStore } from "@/stores/corporate";
import { useInsurerStore } from "@/stores/insurer";
import { usePatientsStore } from "@/stores/patients";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useCommonStore } from "@/stores/common";

const headerStore = useHeaderStore();
const corporateStore = useCorporateStore();
const insurerStore = useInsurerStore();
const patientsStore = usePatientsStore();
const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();
const isMouseOver = ref(null);

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const navBarStyle = (id) => {
  //debugger;
  if (id != undefined) {
    let style = "background-color: var(--" + id + "-color);";
    return style;
  } else return "background: transparent";
};

const updateMouseOver = (index) => {
  isMouseOver.value = index;
};

const isMatchCurrentPath = (id) => {
  return headerStore.routerName == id;
};

const click = (item, menu) => {
  headerStore.currentMenu = menu;
  goToLocation(item.id);
}

const goToLocation = (id) => {
  headerStore.routerName = id;

  switch (id) {
    // case "telemedicine":
    case "corptelemedicine":
    case "insutelemedicine":
    case "patitelemedicine":
      routeTo(id);
      break;

    // case "ourcheckuppackages":
    case "insucheckupservices":
    case "paticheckupservices":
    case "servcheckupservices":
      routeTo(id);
      break;

    // case "vaccination":
    case "corpvaccination":
    case "insuvaccination":
    case "pativaccination":
      routeTo(id);
      break;

    // case "nursingservices":
    case "insunursingservices":
    case "patinursingservices":
      routeTo(id);
      break;

    case "factsheet":
      routeTo(id);
      break;

    case "aboutcorporate":
      routeTo(id);
      break;

    case "aboutinsurer":
     routeTo(id);
      break;

    case "aboutpatients":
     routeTo(id);
      break;

    case "aboutservices":
      routeTo(id);
      break;

    case "tpa":
      routeTo(id);
      break;

    // comingsoon
    case "emergencyassistance":
    case "ourvalues":
    case "ourteam":
    case "ourservices":
    case "ourfacilities":
      routeTo(id);
      break;

    default:
      routeTo("comingsoon");
      break;
  }
  // headerStore.selectedMenu = {};
};

router.beforeEach((to, from) => {
  headerStore.routerName = to.name;
  window.scrollTo(0, 0);
});

</script>

<style>
.hover-border {
  position: relative;
  display: inline-block;
  padding: 0.3em 1.1em;
  border: 0.1em solid transparent;
  border-radius: 60em;
}

.hover-border::before {
  content: "";
  position: absolute;
  top: -0.1em;
  left: -0.1em;
  right: -0.1em;
  bottom: -0.1em;
  border: 0.1em solid transparent;
  border-radius: 20em;
}

.hover-border-active::before {
  border-color: #ffffff; /* Set your desired border color */
}

.hover-border:hover::before {
  border-color: #ffffff; /* Set your desired border color */
}

.hover-border-selected {
  color:  #603813;
  background-color: #ffffff;
}

.hover-border-selected.corpColor {
  color:  #8F8248;
}

.hover-border-selected.insuColor {
  color:  #82488F;
}

.hover-border-selected.patiColor {
  color:  #488F82;
}
</style>